import React from 'react';
import {
  LiveKitRoom,
  FocusLayoutContainer,
  ParticipantTile,
  useTracks,
  RoomAudioRenderer,
} from '@livekit/components-react';
import CustomControlBar from './CustomControlBar';
import '@livekit/components-styles';

export default function QuestionLiveKitModal({ token, serverUrl, onLeave }) {
  if (!token || !serverUrl) return null;

  function FocusLayoutContent() {
    const tracks = useTracks([
      { source: 'camera', withPlaceholder: false },
    ]);
    // Lokalen Teilnehmer finden
    const local = tracks.find(t => t.participant.isLocal);
    // Remote Teilnehmer (nur den ersten im Fokus)
    const remote = tracks.find(t => !t.participant.isLocal);

    return (
      <>
        <FocusLayoutContainer>
          {local ? (
            <ParticipantTile
              trackRef={local}
              style={{ width: 'auto', borderRadius: 8, boxShadow: '0 2px 8px #0002', overflow: 'hidden', aspectRatio: '16/9' }}
            />
          ) : (
            <div style={{ width: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', aspectRatio: '16/9' }}>Kein eigenes Video</div>
          )}
          {remote ? (
            <ParticipantTile
              trackRef={remote}
              style={{ height: 'stretch', borderRadius: 8, overflow: 'hidden', aspectRatio: '16/9' }}
            />
          ) : (
            <div style={{ height: 'stretch', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 22, aspectRatio: '16/9' }}>Warte auf Gesprächspartner ...</div>
          )}
        </FocusLayoutContainer>
        <CustomControlBar onLeave={onLeave} />
      </>
    );
  }

  return (
    <LiveKitRoom
      token={token}
      serverUrl={serverUrl}
      connect={true}
      video={true}
      audio={true}
      onDisconnected={onLeave}
      data-lk-theme="default"
      style={{ width: '100%', height: '100%' }}
    >
      <FocusLayoutContent />
      <RoomAudioRenderer />
    </LiveKitRoom>
  );
}
